export const education = [
  { value: '1', label: 'No Formal Education' },
  { value: '2', label: 'Primary Education' },
  { value: '3', label: 'Secondary Education' },
  { value: '4', label: 'Bachelors Degree' },
  { value: '5', label: 'Masters Degree' },
  { value: '6', label: 'Doctorate or Higher' },
];
